import React from 'react';
import Property from '../../properties/Property';
import './styles.css';

const SummaryStep = ({ fields, imagePreviewUrls }) => (
  <div className="step-content big summary-step">
    <span className="icon-checkmark-big" />
    <h2>Til hamingu!</h2>
    <p>
      Auglýsingin þín er tilbúin! <br />
      Nú geturðu sett auglýsinguna í loftið, fengið þér
      kaffibolla og fylgst með umsóknunum hrannast upp!
    </p>
    <div className="summary-wrapper">
      <Property
        property={{
          address: fields.address.value.indexOf(',') !== -1 ?
            fields.address.value.substring(0, fields.address.value.indexOf(',')) :
            fields.address.value,
          price: fields.price.value,
          zip: parseInt(fields.zip.value, 10),
          type: fields.type.value,
          bedrooms: fields.bedrooms.value,
          size: fields.size.value,
          imageDownloadUrls: imagePreviewUrls,
        }}
        presentational
      />
    </div>
  </div>
);

SummaryStep.propTypes = {
  fields: React.PropTypes.object.isRequired,
  imagePreviewUrls: React.PropTypes.array.isRequired,
};

export default SummaryStep;



// WEBPACK FOOTER //
// ./src/browser/steps/SummaryStep/SummaryStep.js